export default "__VITE_ASSET__D19ABVRk__"